

import { useGetLocationQuery, useGetLocationListQuery, useGetLocationPresentationQuery } from "../../../../location/apis/Location.api";
import { Search, Refresh, Clear, RemoveCircle, AddCircleOutlineOutlined, ManageSearch } from "@mui/icons-material";
import { LocationNameDisplay, default as LocationName } from "../../../../location/components/location/LocationDetail/LocationName";
import { toString as toStringLocation, PrimaryLocation } from "../../../../location/types/models/Location";
import React from "react";
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Container,
    Stack,
    Button,
    FormControl,
    Divider,
} from "@mui/material";

import { object, string, number, boolean, date, coerce, TypeOf, array } from 'zod';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import * as crudgen from "../../../../share";
import {formatDateTime, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import {useDebounce} from "react-use";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useDispatch} from "react-redux";
import useSearch from "../../../../hooks/useSearch";
import { Trans } from "@lingui/react/macro";
import { t, msg } from "@lingui/core/macro";

export const initialFormStateFn = () => { return {
    
    
    
        parentId: [],
        
    
} }

export const formObject = {
    
        name: string()
        .trim()
        .nullish(),
        
        
    
        hierarchyName: string()
        .trim()
        .nullish(),
        
        
    
        parentId: array(string()
            .nullish()),
        
        
        parentIdInclude: boolean().default(false),
        
    
};

export const formSchema = object(formObject);

export type FormInput = TypeOf<typeof formSchema>;

type IProps = {
    prefix?: string;
    setSearchInputValue: (search: string) => void;
    searchInputAdvanced: any;
    setSearchInputAdvanced: (any) => void;
    query: any;
    refetch: () => void;
}

const LocationListSearch = (props: IProps) => {
    
    const {advancedSearch, search, updateSearch} = useSearch('Location')
    
    const [advanced, setAdvanced] = React.useState(advancedSearch);
    
    const {prefix = '', query} = props;
    
    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: advanced ? search : initialFormStateFn()
    });

    const {
        reset,
        watch,
        handleSubmit,
        formState: { isSubmitSuccessful },
    } = methods;
    
    
    const [, setLocationInputValue, locationInputTerm] = useSearchDebounce();
    const { data: locationList = {
        items: [],
        totalItems: 0,
        page: 0,
        pageSize: 12,
        numPages: 0
    },
        isLoading: getLocationListLoading,
        isFetching: getLocationListFetching, 
    } = useGetLocationPresentationQuery({
        list: {
            page: 0,
            pageSize: 12,
        },
        filter: {
            hierarchyName: locationInputTerm || '',
                    hierarchyNameOr: true,
                    },
    })
    
    
    
    const cancelSearch = React.useCallback((e: any) => {
        e.stopPropagation()
        props.setSearchInputAdvanced(undefined)
        setAdvanced(false)
    })
    
    const onAdvancedSubmitHandler: SubmitHandler<FormInput> = (values, e: any) => {
        props.setSearchInputAdvanced(values)
    };

    const parentIdInclude = watch(prefix + 'parentIdInclude');

    React.useEffect(() => {
        if (!advancedSearch) {
            props.setSearchInputValue(search)
        }
    }, []);

    const [advancedFormValues, setAdvancedFormValues] = React.useState(advanced ? search : initialFormStateFn())

    const [, cancelAdvancedFormValues] = useDebounce(() => {
        if (advanced) {
            handleSubmit(onAdvancedSubmitHandler)()
            updateSearch(advanced, advancedFormValues)
        }
    }, DEBOUNCE_TIME, [advancedFormValues, advanced])

    React.useEffect(() => {
        const subscription = watch((values) => {
            setAdvancedFormValues(values)
        });
        return () => {
            cancelAdvancedFormValues()
            subscription.unsubscribe()
        }
    }, [watch, cancelAdvancedFormValues]);
        
    if (!advanced)
    return (<Box
        component="form"
        onSubmit={(e) => {e?.preventDefault()}}
        noValidate
        sx={ { '& > :not(style)': { m: 1, width: '100%', padding: '1em' } } }
        autoComplete="off"
        data-testid="Location-search-form"
    >
        <TextField
            defaultValue={ !advancedSearch ? search : '' }
            label={t`Search (by Hierarchy Name)`}
            onChange={ (event) => {
                props.setSearchInputValue(event.target.value)
                updateSearch(false, event.target.value)
            } }
            variant="standard"
            slotProps={ {
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    props.setSearchInputValue('')
                                    updateSearch(false, '')
                                } }
                                edge="end"
                            >
                                <Clear />
                            </IconButton>
                            <IconButton
                                onClick={() => setAdvanced(!advanced)}
                                edge="end"
                            >
                                <ManageSearch />
                            </IconButton>
                            
                            <IconButton
                                onClick={props.refetch}
                                edge="end"
                            >
                                <Refresh />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            } }
        />
    </Box>)
    if (advanced)
        return (<Container sx={ { marginBottom: '1em' } }>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={handleSubmit(onAdvancedSubmitHandler)}
                    noValidate
                    data-testid="Location-advanced-search-form"
                >
                    <FormControl fullWidth size="small">
                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'name' }
                    label={t`Name`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        
        
            
            <crudgen.FormInput
                    
                    name={ prefix + 'hierarchyName' }
                    label={t`Hierarchy Name`}
                    clearable={true}
                    
                    
                    type='text'
                    
            />
            
        
    

                        <Box sx={ {display: 'flex'} }>
        
        <crudgen.AsyncFormSelect
                
                name={ prefix + 'parentId' }
                optionsLoading={ getLocationListLoading || getLocationListFetching }
                label={t`Location`}
                options={ locationList.items }
                valueMap={ (id) => useGetLocationQuery(PrimaryLocation.fromId(id), {skip: !id}) }
                optionLabelMap={ toStringLocation }
                onInputChange={ setLocationInputValue }
                renderOption={(optionProps, option, { inputValue }) => {
                    const { key, ...filteredOptionProps } = optionProps;
                    return (<li key={key} {...filteredOptionProps}><LocationNameDisplay data={option}/></li>)
                } }
                disabled={ !!parentIdInclude }
                
                renderValue={(value, getItemProps) =>
                    value.map((option: any, index: number) => {
                        const { key: _key, ...tagProps } = getItemProps({ index })
                        return (
                            <crudgen.SelectChip key={index} {...tagProps}>
                                <LocationName id={option}/>
                            </crudgen.SelectChip>
                        );
                    })
                }
                multiple
                
            
        />
        
    
<crudgen.FormCheckbox
        name={ prefix + 'parentIdInclude' }
        icon={<AddCircleOutlineOutlined />}
        checkedIcon={<RemoveCircle />}
    />
</Box>
                        
                        
                        <Stack direction="row" spacing={1}>
                            <Button size="small"  variant="outlined" color="primary" type='submit' sx={ {display: 'none'} }>
                                <Search /> <Trans>Search</Trans>
                            </Button>
                            <Button size="small"  variant="outlined" color="primary" onClick={props.refetch}>
                                <Refresh /> <Trans>Refresh</Trans>
                            </Button>
                            <Button size="small" variant="outlined" onClick={cancelSearch} color="inherit">
                                <Trans>Cancel</Trans>
                            </Button>
                        </Stack>
                    </FormControl>
                </Box>
            </FormProvider>
        </Container>)
    
}

export default LocationListSearch;
